module.exports = __webpack_public_path__ + "static/media/close-icon.2672748e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/svg/close-icon.svg
// module id = 1320
// module chunks = 0